'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeckoDates = function () {
    function GeckoDates() {
        _classCallCheck(this, GeckoDates);
    }

    _createClass(GeckoDates, null, [{
        key: 'formatDate',


        /*
        * Format timestamp to local time
        */

        value: function formatDate(timestamp, format) {
            if (timestamp) {
                var _format = format || 'MMM Do YYYY [at] HH:mm';
                return (0, _moment2.default)(timestamp, 'X').format(_format);
            }
            return '';
        }

        /*
        * Format timestamp to UTC time
        */

    }, {
        key: 'formatDateUTC',
        value: function formatDateUTC(timestamp, format) {
            if (timestamp) {
                var _format = format || 'MMM Do YYYY [at] HH:mm';
                return _moment2.default.utc(timestamp, 'X').format(_format);
            }
            return '';
        }

        /*
        * Format timestamp to specified timezone time
        */

        // static formatDateTimezone(timestamp, timezone format) {

        // }

    }]);

    return GeckoDates;
}();

exports.default = GeckoDates;